import { useState } from 'react';
import { classNames, profileName } from 'src/utilities';
import { Image } from '.';
import { generateColor } from 'src/modules/SuperAdmin/components/pageComponents/SuperAdmin/Prompts/utils';

export const ProfileLogo = ({
  base64Image = null,
  name = '? ?',
  className,
  filteredData,
  practitionersAndPatients,
  getAllTemplatesExchangeList,
  practitionersOrgLevel,
}) => {
  const [imgError, setImgError] = useState(false);
  const appointmentwithColors = {};

  if (filteredData) {
    filteredData.forEach((appointment) => {
      const name = `${appointment?.practitioner_firstName} ${appointment?.practitioner_lastName}`;
      if (name && !appointmentwithColors[name]) {
        const color = generateColor(name);
        appointmentwithColors[name] = color;
      }
    });
  }

  if (
    practitionersAndPatients &&
    Array.isArray(practitionersAndPatients?.practitioner)
  ) {
    practitionersAndPatients?.practitioner.forEach((appointment) => {
      const name = `${appointment?.first_name} ${appointment?.last_name}`;
      if (name && !appointmentwithColors[name]) {
        const color = generateColor(name);
        appointmentwithColors[name] = color;
      }
    });
  }

  if (
    getAllTemplatesExchangeList &&
    Array.isArray(getAllTemplatesExchangeList)
  ) {
    getAllTemplatesExchangeList?.map((appointment) => {
      const practitionerName = appointment.practitioner_name;
      const nameWithoutDr = practitionerName.replace('Dr. ', '');
      let [firstName, lastName] = nameWithoutDr.split(' ');

      if (!lastName) {
        lastName = '';
      }

      const name = `${firstName} ${lastName}`.trim();
      if (name && !appointmentwithColors[name]) {
        const color = generateColor(name);
        appointmentwithColors[name] = color;
      }
    });
  }

  if (practitionersOrgLevel && Array.isArray(practitionersOrgLevel)) {
    practitionersOrgLevel?.map((practitioner) => {
      const practitionerName = practitioner.practitioner_name.trim();
      const nameWithoutDr = practitionerName.replace('Dr. ', '');

      if (!nameWithoutDr.includes('Dr. ')) {
        if (!appointmentwithColors[name]) {
          const color = generateColor(name);
          appointmentwithColors[name] = color;
        }
      }
    });
  }

  const backgroundColor = appointmentwithColors[name] || '#00d091';

  return (
    <>
      {base64Image && !imgError ? (
        <div
          className={classNames('profile-picture', className ? className : '')}
        >
          <Image
            className=""
            src={base64Image}
            alt="user"
            onError={() => setImgError(true)}
          />
        </div>
      ) : (
        <div
          className={classNames(
            'profile-picture-name flex justify-center items-center',
            className ? className : ''
          )}
          style={{
            background: backgroundColor,
          }}
        >
          {name && profileName(name)}
        </div>
      )}
    </>
  );
};
